import styled from 'styled-components';

const QDropdown = styled.div`
  position: relative;
`;

export default QDropdown;
